export enum formFields {
  F01 = "name",
  F02 = "email",
  F03 = "subject",
  F04 = "message",
}
